<div class="main-section overview-timeline overview-timeline-custom">
    <section class="">
        <div class="content-wrapper no-padding animated-half slideTop">
            <div class="overview-block">
                <div class="overview-middle">
                    <div class="overview-middle-inner">
                        <app-widget-container (drop)="onDrop($event, 'M1')" (dragover)="onDragOver($event)" [widgets]="M1"></app-widget-container>
                    
                    </div>
                </div>
           
            </div>
        </div>
    </section>
</div>
<router-outlet></router-outlet>
<app-widget-container *ngIf="sps.isActiveWall" [widgets]="sps.compList['panel']"></app-widget-container>
<!-- <app-customize-panel [show]="show"></app-customize-panel> -->